import React from 'react';
import AdvancedFilters, { FilterConfig } from './AdvancedFilters';

/**
 * Versão mobile (drawer) de `ClientOnlyFilters` — mesmo par desktop/mobile de
 * `SuggestionsFilters`/`MobileSuggestionsFilters`.
 */
export const MobileClientOnlyFilters: React.FC = () => {
  const filterConfig: FilterConfig = {
    showClientFilter: true,
    showDateRangeFilter: false,
    showCategoryFilter: false,
    showPriorityFilter: false,
    showQrCodeFilter: false,
    showSimilarOnlyFilter: false,
    pageType: 'reports',
    variant: 'mobile',
  };

  return <AdvancedFilters config={filterConfig} />;
};

export default MobileClientOnlyFilters;
